import { getSubscribeReceiverList } from '@/pages/dashboard/services/substribe';
import { useState, useEffect } from 'react';

interface Props {
  gameCode: string;
  menuId: string;
  subscribeId: string;
}

const useReceiverList = (props: Props) => {
  const { gameCode, menuId, subscribeId } = props;
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<any>([]);

  useEffect(() => {
    getSubscribeReceiverList({
      game_code: gameCode,
      menu_id: menuId || '',
      subscribe_id: subscribeId || ''
    })
      .then((res) => {
        const list = res?.List?.map(item => ({
          text: item?.user_name,
          value: item?.user_id,
          email: item?.email
        }));
        setList(list);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [gameCode, menuId]);

  return {
    loading,
    receiverList: list
  };
};

export default useReceiverList;
